import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import './ResetPassword.scss';
import { forgotPassword } from './redux/actions';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { getResetPasswordEmailSent } from './redux/selectors';
import { SubmitButton } from '../../shared/button/submit-button/SubmitButton';
import { InputField } from '../../shared/input-field/InputField';

class ResetPassword extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: null
        };
    }

    handleEmailChange = email =>
        this.setState({
            ...this.state,
            email
        });

    handleSubmit = event => {
        event.preventDefault();
        _.isFunction(this.props.forgotPassword) &&
            this.props.forgotPassword(this.state.email);
    };

    render() {
        const { resetPasswordEmailSent } = this.props;
        return (
            <div className="reset-password-container">
                <span className="reset-message">Reset Password</span>
                {resetPasswordEmailSent ? (
                    <div className={'info-message'}>
                        <span>
                            If your profile exists, we have sent an email to {' '}
                            <span className={'user-email'}>
                                {this.state.email}
                            </span>.
                            Open the link in the email to reset your password.
                        </span>
                    </div>
                ) : (
                    <Fragment>
                        <form onSubmit={this.handleSubmit}>
                            <InputField
                                type="text"
                                name="username"
                                placeholder="Email"
                                required={true}
                                onChange={email =>
                                    this.handleEmailChange(email.target.value)
                                }
                            />
                            <SubmitButton text={'Send reset link'} />
                        </form>
                        <span className="reset-password-footer">
                            Already have an account?
                            <Link className="login-link" to="/login">
                                Login
                            </Link>
                        </span>
                    </Fragment>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    resetPasswordEmailSent: getResetPasswordEmailSent(state)
});

const mapDispatchToProps = dispatch => ({
    forgotPassword: email => dispatch(forgotPassword({ email }))
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
